import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../get-base-url';
import { useParams } from 'react-router-dom';
import ResearchDeathNonResidentNotificationShared from '../../research-notifications/research-death-non-resident';
import { BreadcrumbItem } from '../../breadcrumb';

interface ResearchDeathNonResidentNotificationCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const ResearchDeathNonResidentNotificationCivilStatusShared = ({
  scope,
  items,
}: ResearchDeathNonResidentNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const editSipoUrl: string = useMemo(() => {
    return `${goBackUrl}/morte/non-residenti/persona-sipo`;
  }, [goBackUrl]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/morte/non-residenti/cancellazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <ResearchDeathNonResidentNotificationShared
        goBackUrl={goBackUrl}
        editSipoUrl={editSipoUrl}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

ResearchDeathNonResidentNotificationCivilStatusShared.displayName =
  'Research Death Non Resident Notifications Page component';

export default ResearchDeathNonResidentNotificationCivilStatusShared;
